import { IMitsPDF } from '../../../../interfaces/mits-pdf';

/**
 * Hilfsklasse zum Transformieren von Bildern
 */
export class ImageGenerator {
  public imageCounter = 0;
  private docDef: IMitsPDF;

  constructor(docDef: IMitsPDF) {
    this.docDef = docDef;
  }

  /**
   * Bild hinzufügen
   * @param img to attach as dataURL
   * @return image variable name
   */
  public attachImage(img: string): string {
    const name = 'image' + this.imageCounter;
    this.docDef.images[name] = img;
    this.imageCounter++;
    return name;
  }
}
